import { chakra } from '@chakra-ui/react'
import * as React from 'react'

export const Pre = (props) => (
  <chakra.div my='2em' borderRadius='sm' {...props} />
)
